import { cn } from "@/utils";

export const Scrubber = ({
  handleSeek,
  handleScrub,
  progressPercentage,
  bufferedPercentage,
  isAudio,
}: {
  handleSeek: (event: React.MouseEvent<HTMLDivElement>) => void;
  handleScrub: (event: React.MouseEvent<HTMLDivElement>) => void;
  progressPercentage: number;
  bufferedPercentage: number;
  isAudio?: boolean;
}) => (
  <div
    className="group flex h-7 flex-grow cursor-pointer items-center"
    onClick={handleSeek}
    onMouseMove={handleScrub}
  >
    <div className="relative h-1 w-full rounded-[4px] bg-[#cacaca80]">
      <div
        className={cn(
          "absolute left-0 top-0 h-1 rounded-[4px] bg-white opacity-35 transition-[width] duration-300 ease-in-out",
          isAudio ? "bg-grey50" : "bg-white",
        )}
        style={{ width: `${bufferedPercentage}%` }}
      />
      <div
        className={cn(
          "absolute left-0 top-0 h-1 rounded-[4px] bg-white",
          isAudio ? "bg-grey50" : "bg-white",
        )}
        style={{ width: `${progressPercentage}%` }}
      />
      <div
        className={cn(
          "absolute top-1/2 h-[10px] w-[10px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white opacity-0 transition-opacity duration-200 group-hover:opacity-100",
          isAudio ? "bg-grey50" : "bg-white",
        )}
        style={{ left: `${progressPercentage}%` }}
      />
    </div>
  </div>
);
